import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import CenSpcShippingDisableState from "@tCentro/Store/Reducer/CenSpcShippingDisableState";
import { Draft } from "immer";

const initialState: CenSpcShippingDisableState = {
    isShippingStateDisabledValue:true,
};

const reducer = {
    "Pages/OnePageCheckout/CenSpcIsShippingDisabled": (draft: Draft<CenSpcShippingDisableState> ,
         action: {
        isShippingStateDisabledValue: boolean;
    },) => {
        draft.isShippingStateDisabledValue = action.isShippingStateDisabledValue;
    },
};

export default createTypedReducerWithImmer(initialState, reducer);